import React, { useState, useEffect, useCallback } from 'react'
import './styles.scss'
import './globals.scss'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Toggle from 'react-toggle'

export const TableCountry = ({ gender, title, subtitle, men, women, lang }) => {
  const [isToggle, setToggle] = useState(false)
  const handleToggleChange = useCallback(() => {
    setToggle((isToggle) => !isToggle)
  }, [])

  useEffect(() => {
    if (gender === 0) {
      setToggle(false)
    } else {
      setToggle(true)
    }
  }, [gender])

  return (
    <div className='graphic chart' id='tableCountryToggle'>
      <div className='title'>
        {title}
        <div className='subtitle'>{subtitle}</div>
      </div>
      <div className='toggleWrapper'>
        <div className='center'>
          <div className={'label ' + (isToggle ? 'off' : '')}>{women}</div>
          <div className='toggleContainer'>
            <Toggle
              checked={isToggle}
              icons={false}
              onChange={handleToggleChange}
            />
          </div>
          <div className={'label right ' + (!isToggle ? 'off' : '')}>{men}</div>
        </div>
      </div>

      <div
        className='switch'
        style={{ position: 'relative', display: 'block' }}
      >
        <div
          style={{
            opacity: !isToggle ? '0' : '1.0',
            position: !isToggle ? 'absolute' : 'relative',
            display: 'inline-block',
            top: '0',
            zIndex: !isToggle ? 1 : 99,
            width: '100%',
          }}
        >
          <AutofitIFrame
            src={
              lang === 'de'
                ? '//datawrapper.dwcdn.net/iSF3o/'
                : '//datawrapper.dwcdn.net/gL0oY/'
            }
          />
        </div>
        <div
          style={{
            opacity: isToggle ? '0' : '1.0',
            position: isToggle ? 'absolute' : 'relative',
            top: '0',
            zIndex: !isToggle ? 99 : 1,
            width: '100%',
          }}
        >
          <AutofitIFrame
            src={
              lang === 'de'
                ? '//datawrapper.dwcdn.net/xrrz1/'
                : '//datawrapper.dwcdn.net/BUiZr/'
            }
          />
        </div>
      </div>
    </div>
  )
}
